import { object, string, TypeOf } from 'yup';

export const CreateProjectSchema = object({
  name: string().required(),
  address: string(),
  subscriberName: string(),
  status: string().required(),
  city: string(),
  state: string(),
  numberConstCenter: string().matches(/^[0-9]*$/, 'Solo se permite números'),
  descriptionConstCenter: string(),
  numberConstructionSite: string().matches(
    /^[0-9]*$/,
    'Solo se permite números',
  ),
  descriptionConstructionSite: string(),
});

export type CreateProjectType = TypeOf<typeof CreateProjectSchema>;
